import React from 'react'
import { alpha } from '@mui/material'
import { PopoverSeeker } from "@ui-seeker/core"
import PopoverTitle from "./Title"
import PopoverLinks from "./Links"
import PopoverCarFeatures from "./Features"
import { dsColorNew } from "@palette"


export default function AnalyzerPopover({ isOpen, onClose, data, hideEvolution = false }) {

	const { price_data, evolutionFilter } = data
	return <PopoverSeeker
		anchorEl={isOpen}
		onClose={onClose}
		anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
		transformOrigin={{ vertical: 'center', horizontal: 'left' }}
		arrowProps={{ sx: { top: '35%', left: -6 } }}
		slotProps={{ paper: { sx: { p: 0, width: 300, borderRadius: '12px', border: `1px solid ${dsColorNew.grayBorder}`, boxShadow: `0 16px 40px ${alpha(dsColorNew.navy, 0.16)}`, backgroundColor: dsColorNew.white } } }}
	>
		<PopoverTitle onClose={onClose} carDescription={price_data?.car_description}/>
		<PopoverCarFeatures priceData={price_data}/>
		<PopoverLinks
			id_search={price_data?.id_search}
			screenshot={price_data?.screenshot}
			evolutionFilter={evolutionFilter}
			priceData={price_data}
			hideEvolution={hideEvolution}
		/>
	</PopoverSeeker>
}